import React, {  Component } from 'react';
import _ from 'lodash';

class ChangeZipCodeOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: true,
			errorMessage: '',
			param: {
				zip: this.props.zipCode
			},
			error: {
				zipError: ''
			}
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ChangeZipCodeOverlayDialog');
    }
	onChangeZip(event) {
		this.setState({
			param: {
				zip: event.target.value
			},
			error: {
				zipError: ''
			}
		});
	}
	handleGo(event) {
		event.preventDefault();
		if (this.state.param.zip.trim() && this.state.param.zip.length === 5) {
             this.props.getShippingAddressesDetails(this.state.param.zip, false, 'adc_loc', (resp) =>{
                if (!resp) {
                    this.setState({
                        error: {
                            ...this.state.error,
                            zipError: 'error'
                        }
                    });
                      this.props.handleSelectZipCode(this.state.param.zip);
                } else {
                    localStorage.setItem("zipCodeChanged", true);
                    this.props.saveCustomADC(resp.agentid);
                    this.props.handleSelectZipCode(this.state.param.zip);
                    let CustomZipCode = this.state.param.zip.trim();
                    let shippingAddressDetail = _.find(this.props.shippingAddressDetailsListWithZipCode, {zipCode: CustomZipCode});
                    let sdsLocObject = _.find(shippingAddressDetail && shippingAddressDetail.details, {loctype: "sds_loc"});
                    sdsLocObject && this.props.updateServicePricing(sdsLocObject);
                }
            }, true, "");
		} else {
			this.setState({
				error: {
					...this.state.error,
					zipError: 'error'
				}
			});
              this.props.handleSelectZipCode(this.state.param.zip);
		}
	}
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="addShippingAddressOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <h2 className="title">Select Zip Code</h2>
					<p className="red bold">{this.state.errorMessage}</p>
                    <form className="addNewShippingAddressForm" onSubmit={(e) => e.preventDefault()}>
                        <table width="100%" className="addNewShippingAddressTable">
                            <tbody>
								<tr>
									<td>
										Availability will be shown for this zip code until you change it or logout.<br /><br />
									</td>
								</tr>
                                <tr>
                                    <td>
                                        <input type="text" onKeyPress={this.props.acceptNumbersOnly} className={this.state.error.zipError} onChange={this.onChangeZip.bind(this)} name="zip" size={20} maxLength={5} value={this.state.param.zip} />
										&nbsp;<a className="blueButton" onClick={this.handleGo.bind(this)}>GO</a>
									</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="noButtonContainer">
                          	<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default ChangeZipCodeOverlayDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeZipCodeOverlayDialog.js